import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = () => {
  const auth   = inject(AuthService);
  const router = inject(Router);

  // Fast path: already authenticated in this tab
  if (auth.isLoggedIn()) return true;

  // Redirect to login — the SSO flow (via /sso route) handles cross-subdomain
  // re-authentication without going through this guard.
  router.navigate(['/app/auth/login']);
  return false;
};
